import {
    LayoutDashboard,
    Activity,
    Boxes,
    Warehouse,
    ClipboardCheck,
    PackageSearch,
    MapPin
} from "lucide-react";

/**
 * Struktur menu. Tambah menu baru cukup di sini — dipakai sidebar desktop
 * maupun drawer mobile.
 */
export const MENU_GROUPS = [
    {
        title: "Monitoring",
        items: [
            { to: "dashboard", label: "Dashboard", icon: LayoutDashboard },
            { to: "inventory", label: "Inventory", icon: PackageSearch },
            { to: "location", label: "Location", icon: MapPin }
        ]
    },
    {
        title: "Master data",
        items: [
            { to: "palette", label: "Master Palet", icon: Boxes },
            { to: "raking", label: "Master Rak", icon: Warehouse }
        ]
    },
    {
        title: "Laporan",
        items: [
            { to: "analytics", label: "Analytics", icon: Activity },
            { to: "report-stock", label: "Rekonsiliasi Stok", icon: ClipboardCheck }
        ]
    }
];

